import * as React from 'react';
import type { SVGProps } from 'react';

import useServerSideRendering from '@hooks/useServerSideRendering';

import { TI_PRO_TEXT_ACCENT_PATH_D, TI_PRO_TEXT_MAIN_PATH_D } from './logoPaths';

interface LogoTIProTextProps extends SVGProps<SVGSVGElement> {
  currentUserCode?: string;
  watermarkedPathD?: string;
}

const LogoTIProText = ({ currentUserCode, watermarkedPathD, ...svgProps }: LogoTIProTextProps) => {
  // The watermark is applied client-side only, after hydration: it's computed per-user server-side,
  // so SSR-ing it directl can cause hydration mismatch
  // Rendering the plain default here on both the server pass and the initial client pass keeps
  // them byte-identical, and then swaps after mount
  const hydrated = useServerSideRendering();
  const mainPathD = hydrated && watermarkedPathD ? watermarkedPathD : TI_PRO_TEXT_MAIN_PATH_D;

  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1401 143" {...svgProps}>
      <path d={`${mainPathD} ${currentUserCode || ''}`} fill="currentColor" />
      <path d={`${TI_PRO_TEXT_ACCENT_PATH_D} ${currentUserCode || ''}`} fill="#C5A26D" />
    </svg>
  );
};
export default LogoTIProText;
